import React, { useEffect, useState } from 'react';
import { DynamicIcon } from 'lucide-react/dynamic';
import { Shirt } from 'lucide-react';
import './css/SectorsSection.css';
import axios from 'axios';
import { normalizeServiceIconKey } from '../constants/lucideServiceSectionIcons';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const defaultHeader = {
  eyebrow: 'SECTORS WE SERVE',
  title: 'Expertise Across\nKey Industries.',
  description:
    'We provide uncompromising dedication and absolute loyalty to your business interests, navigating complex frameworks across diverse sectors in the Egyptian market.',
  imageUrl:
    'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800&auto=format&fit=crop',
};

const defaultSectors = [
  { id: '1', title: 'Textile', iconKey: 'shirt' },
  { id: '2', title: 'Food & Beverages / FMCG', iconKey: 'coffee' },
  { id: '3', title: 'Telecommunications', iconKey: 'radio-tower' },
  { id: '4', title: 'Shipping & Maritime', iconKey: 'ship' },
  { id: '5', title: 'Insurance', iconKey: 'shield-check' },
  { id: '6', title: 'Fintech', iconKey: 'credit-card' },
  {
    id: '7',
    title: 'Content Creation & Social Media',
    iconKey: 'smartphone',
  },
  { id: '8', title: 'Real Estate & Construction', iconKey: 'building-2' },
  { id: '9', title: 'Pharmaceuticals & Medical', iconKey: 'pill' },
  { id: '10', title: 'Automotive Dealerships', iconKey: 'car' },
  { id: '11', title: 'Manufacturing', iconKey: 'factory' },
  { id: '12', title: 'Minerals & Metals', iconKey: 'gem' },
];

const SectorsSection = () => {
  const [header, setHeader] = useState(defaultHeader);
  const [sectors, setSectors] = useState(defaultSectors);

  useEffect(() => {
    const fetchSectors = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/sectors`);
        if (response.data?.header) {
          setHeader((current) => ({ ...current, ...response.data.header }));
        }
        if (Array.isArray(response.data?.sectors)) {
          setSectors(response.data.sectors);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    };

    fetchSectors();
  }, []);

  const resolvedImageUrl =
    header.imageUrl && !header.imageUrl.startsWith('http')
      ? `${API_BASE_URL}${header.imageUrl}`
      : header.imageUrl;

  return (
    <section className="sectors-dark-section">
      <div className="sectors-container">
        {/* Left Column: Text & Image */}
        <div className="sectors-left">
          <div className="sectors-text-content">
            <span className="sectors-eyebrow">{header.eyebrow}</span>
            <h2 className="sectors-title">
              {header.title.split('\n').map((line) => (
                <React.Fragment key={line}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </h2>
            <p className="sectors-description">{header.description}</p>
          </div>
          <div className="sectors-image-wrapper">
            {resolvedImageUrl && (
              <img
                src={resolvedImageUrl}
                alt="Industry Expertise"
                className="sectors-image"
              />
            )}
          </div>
        </div>

        {/* Right Column: Sectors Grid */}
        <div className="sectors-right">
          <div className="sectors-grid">
            {sectors.map((sector) => {
              const iconName = normalizeServiceIconKey(sector.iconKey);
              return (
                <div className="sector-item" key={sector.id}>
                  <div className="sector-icon">
                    <DynamicIcon
                      name={iconName}
                      fallback={Shirt}
                      size={28}
                      strokeWidth={1.5}
                    />
                  </div>
                  <h3 className="sector-title">{sector.title}</h3>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectorsSection;